import { LazoPaths } from "@/enums/LazoPaths";
import i18n from "@/i18n/config";
import AuditableEntity from "@/types/AuditableEntity";

export type AddOn = AuditableEntity & {
  name: string;
  monthlyIndividualPrice: number;
  objectKey: string;
  description?: string;
  module: AddOnModuleType;
  amount?: number;
};

export enum AddOnModuleType {
  USERS = "USERS",
  ACCOUNTING = "ACCOUNTING",
  INTELLIGENCE = "INTELLIGENCE",
  DATA_ROOM = "DATA_ROOM",
  VIEW_DATA_SHARED_BY_OTHERS = "VIEW_DATA_SHARED_BY_OTHERS",
}

export enum AddOnObjectKeyType {
  EACH_ADDITIONAL_USER = "each-additional-user",
  // Unused / to deprecate
  ACCOUNTING_MODULE = "accounting-module",
  TAX_DUE_DATES = "tax-due-dates",
  SEARCH_CRUNCHBASE = "search-crunchbase",
  SMARTLISTS = "smartlists",
  SMARTLISTS_UP_TO_ONE = "smartlists-up-to-1",
  FILE_SHARED_ROOMS_UP_TO_1 = "file-shared-rooms-up-to-1",
  PIPELINES = "pipelines",
  MASTER_DATA_ROOM = "master-data-room",
  //SHARED_ROOMS_UP_TO_3 = "shared-rooms-up-to-3",
  SHARED_ROOMS_UNLIMITED = "shared-rooms-unlimited",
  SHARED_SPACES = "shared-spaces",
  SHARED_SMARTLISTS = "shared-smartlists",
}

export const AddOnObjectKeyPathMap = {
  [LazoPaths.DASHBOARD]: [AddOnObjectKeyType.ACCOUNTING_MODULE],
  [LazoPaths.TAX_DEADLINES]: [AddOnObjectKeyType.TAX_DUE_DATES],
  [LazoPaths.FUNDRAISING]: [AddOnObjectKeyType.SMARTLISTS, AddOnObjectKeyType.SHARED_SMARTLISTS, AddOnObjectKeyType.SMARTLISTS_UP_TO_ONE],
  [LazoPaths.ONE_VIRTUAL_DATA_ROOMS]: [
    //AddOnObjectKeyType.SHARED_ROOMS_UP_TO_3,
    AddOnObjectKeyType.SHARED_ROOMS_UNLIMITED,
    AddOnObjectKeyType.SHARED_SPACES,
    AddOnObjectKeyType.FILE_SHARED_ROOMS_UP_TO_1,
  ],
};

export const EACH_ADDITIONAL_USER_PRICE = 9.99;

// Mapping from AddOnObjectKeyType to translation keys
const AddOnMessageKeyMap: Record<AddOnObjectKeyType, string> = {
  [AddOnObjectKeyType.EACH_ADDITIONAL_USER]: "eachAdditionalUser",
  [AddOnObjectKeyType.ACCOUNTING_MODULE]: "accountingModule",
  [AddOnObjectKeyType.TAX_DUE_DATES]: "taxDueDates",
  [AddOnObjectKeyType.SEARCH_CRUNCHBASE]: "searchCrunchbase",
  [AddOnObjectKeyType.SMARTLISTS]: "smartlists",
  [AddOnObjectKeyType.SMARTLISTS_UP_TO_ONE]: "smartlistsUpToOne",
  [AddOnObjectKeyType.PIPELINES]: "pipelines",
  [AddOnObjectKeyType.MASTER_DATA_ROOM]: "masterDataRoom",
  [AddOnObjectKeyType.FILE_SHARED_ROOMS_UP_TO_1]: "fileSharedRoomsUpTo1",
  [AddOnObjectKeyType.SHARED_ROOMS_UNLIMITED]: "sharedRoomsUnlimited",
  [AddOnObjectKeyType.SHARED_SPACES]: "sharedSpaces",
  [AddOnObjectKeyType.SHARED_SMARTLISTS]: "sharedSmartlists",
};

export const getAddOnMessage = (key: AddOnObjectKeyType, type: "denied"): string => {
  const translationKey = AddOnMessageKeyMap[key];
  if (translationKey) {
    return i18n.t(`paywall:addOnMessages.${translationKey}.${type}`);
  }
  return i18n.t("paywall:addOnMessages.defaultDenied");
};

export const getAddOnDescription = (key: string, type: "description"): string => {
  const translationKey = AddOnMessageKeyMap[key as AddOnObjectKeyType];
  if (translationKey) {
    return i18n.t(`paywall:addOnMessages.${translationKey}.${type}`, "");
  }
  return "";
};

export const getAddOnNameByKey = (a: AddOn): string => {
  const translationKey = AddOnMessageKeyMap[a.objectKey as AddOnObjectKeyType];
  if (translationKey) {
    const translatedName = i18n.t(`paywall:addOnNames.${translationKey}`, "");
    if (translatedName) {
      return translatedName;
    }
  }
  return a.name;
};
